<template>
  <div class="locale-changer">
    <select v-model="$i18n.locale">
      <option v-for="lang in langs" :key="lang.value" :value="lang.value">{{
        lang.text
      }}</option>
    </select>
  </div>
</template>

<script>
export default {
  name: "locale-changer",
  data() {
    return {
      langs: [
        { value: "zh", text: "正體中文", selected: true },
        { value: "en", text: "English", selected: false },
      ],
    };
  },
};
</script>
<style lang="scss">
.locale-changer {
  position: absolute;
  right: 1rem;
  top: 1rem;
}
</style>
